const round = (n) => Math.round((n + Number.EPSILON) * 100) / 100;
const number = (value) => (Number.isFinite(Number(value)) ? Number(value) : 0);
export function calculateRctiPricing(items, gstType = "Inclusive") {
  const totals = {
    totalAmount: 0,
    totalDiscountAmount: 0,
    totalGSTAmount: 0,
    finalAmount: 0,
  };
  const rows = items.map((item) => {
    const gross = round(number(item.itemPrice) * number(item.itemQuantity));
    const discount = round(
      item.discountType === "Fixed"
        ? number(item.discountValue)
        : ["Percentage", "%"].includes(item.discountType)
        ? (gross * number(item.discountValue)) / 100
        : 0
    );
    const net = round(Math.max(0, gross - discount));
    const rate = gstType === "No GST" ? 0 : number(item.gst);
    const gst = round(
      gstType === "Exclusive" ? (net * rate) / 100 : (net * rate) / (100 + rate)
    );
    const total = round(net + (gstType === "Exclusive" ? gst : 0));
    totals.totalAmount += gstType === "Exclusive" ? gross : round(net - gst);
    totals.totalDiscountAmount += discount;
    totals.totalGSTAmount += gst;
    totals.finalAmount += total;
    return {
      ...item,
      discountAmount: discount,
      totalItemPrice: total,
      totalPriceForItem: total,
    };
  });
  for (const key of Object.keys(totals)) totals[key] = round(totals[key]);
  return { ...totals, items: rows };
}
